const state = {
    data: []
}

const mutations = {
    setData(state, val) {
        state.data = val
    }
}

export default {
    namespaced: true,
    state,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/user.js